import { Http, HttpConfig } from '@zera-admin/classes'
import { storage } from '@zera-admin/helpers'

import { refresh } from 'services/http/interceptors'

const ENV_URL = 'https://alice-api-backoffice.alice.glomil.com'

const http = new Http({
  origin: ENV_URL,
  interceptors: {
    refresh,
  },
})

export function request<T>(config: HttpConfig) {
  config.headers = {
    Authorization: `Bearer ${storage.get('token')}`,
    ...config.headers,
  }

  return http.request<T>(config)
}

export default http
